import stbAPIGateway from '../../../../services/stbAPIGateway';

export const deleteClientHubConfig = async ({ rootGetters }, { clientSid, hubConfig }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const appClientId = hubConfig.userPoolClientId;
  if (!appClientId) {
    throw new Error('User Pool Client ID is required');
  }
  await stbApi.deleteClientHubConfig(clientSid, appClientId);
  return hubConfig;
};
